<template>
  <div class="projectData">
    <el-form :model="queryInfo" class="ly-header__bg" label-width="100px">
      <el-form-item label="所在地区：">
        <EarthAreaSelect
          :country="queryInfo.country"
          :province="queryInfo.province"
          :city="queryInfo.city"
          :region="queryInfo.region"
          @searchCountry="searchCountry"
          @searchProvince="searchProvince"
          @searchCity="searchCity"
        />
      </el-form-item>
      <el-form-item label="所属行业：">
        <SelectTreeRadio
          apiName="getIndustryThree"
          resultType="values"
          storageKey="industryCategory"
          v-model="queryInfo.industryCategory"
          @input="(e) => labelTagChange('industryCategory', e, '所属行业')"
        ></SelectTreeRadio>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="含规上企业：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="enterpriseScale"
              v-model="queryInfo.enterpriseScale"
              @input="(e) => labelTagChange('enterpriseScale', e, '含规上企业')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="含专精特新：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="specialized"
              v-model="queryInfo.specialized"
              @input="(e) => labelTagChange('specialized', e, '含专精特新')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="含小巨人企业：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="enterpriseMin"
              v-model="queryInfo.enterpriseMin"
              @input="(e) => labelTagChange('enterpriseMin', e, '含小巨人企业')"
            ></SelectTreeRadio>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="含上市企业：">
            <SelectTreeRadio
              apiName="getDicRadioButton"
              :params="{ code: '047' }"
              resultType="values"
              vFeild="codeId"
              lFeild="codeName"
              storageKey="enterpriseTop"
              v-model="queryInfo.enterpriseTop"
              @input="(e) => labelTagChange('enterpriseTop', e, '含上市企业')"
            ></SelectTreeRadio>
          </el-form-item> </el-col
      ></el-row>
      <el-form-item label="筛选条件：" class="filterInfo">
        <el-tag
          closable
          v-for="(item, index) in tags"
          :key="index + item.name"
          @close="closeTag(index, item.tagName)"
        >
          {{ item.name }}：{{
            queryInfo[item.tagName] ? queryInfo[item.tagName] : "不限"
          }}
          <span
            class="circle"
            v-if="item.hasOwnProperty('valLength') && item.valLength > 0"
            >+{{ item.valLength }}</span
          >
        </el-tag>
      </el-form-item>
    </el-form>
    <div class="ly-container__bg">
      <div class="ly_operation">
        <div class="left">
          <ImportFilePopup
            moduleName="智参企业"
            templateUrl="/template/智参企业上传.xlsx"
            buttonText="批量上传企业"
            popupTitle="批量新增智参企业"
            templateName="智参企业"
            @uploadSuccess="search"
          />

          <el-button @click="multiDelete">
            批量删除
            <i class="jr-iconjr-icon-delect" />
          </el-button>

          <el-button @click="multiDelete">
            批量导出
            <i class="jr-iconjr-icon-export" />
          </el-button>

          <!-- <popover @popoverClick="popoverClick" /> -->

          <div class="upload_time">
            <div class="caretTime" @click="uploadTime" style="color: #606266">
              按创建时间
            </div>
            <i
              class="el-icon-caret-top"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 0
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[
                queryInfo.columnName == 'create_time' && queryInfo.order == 1
                  ? 'isActiveTime1'
                  : 'iconColor',
              ]"
            />
          </div>
        </div>

        <MySearchInput
          placeholderTxt="根据姓名、昵称进行搜索"
          v-model="queryInfo.name"
          @on-search="search"
          @on-clear="search"
          @on-enter="search"
        ></MySearchInput>
      </div>

      <el-table
        class="ly_table"
        :data="projectTable"
        v-loading="loading"
        :header-cell-style="{ background: '#F5F6F7', color: '#363E4D' }"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'date', order: 'descending' }"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55" align="center" />

        <template slot="empty">
          <img src="@/assets/img/table.png" alt="没有数据" srcset="" />
        </template>

        <!-- 编号列 -->
        <el-table-column label="编号" align="center" width="100" prop="id">
        </el-table-column>

        <!-- 数据完整度列 -->
        <el-table-column label="数据完整度" align="center" width="100">
          <template #default="{ row }">
            <el-progress
              type="circle"
              :width="50"
              :percentage="row.dataIntegrity"
              :color="customColorMethod(row.dataIntegrity)"
            ></el-progress>
          </template>
        </el-table-column>

        <!-- 数据质量列（带进度条效果） -->
        <el-table-column label="数据质量" align="center" width="80">
          <template #default="{ row }"> {{ row.dataQuality }}</template>
        </el-table-column>

        <el-table-column label="名称" prop="name" align="center">
        </el-table-column>

        <el-table-column label="类型" prop="type" align="center">
        </el-table-column>

        <!-- 园区面积对比 -->
        <el-table-column label="园区面积" prop="area" align="center">
        </el-table-column>

        <el-table-column label="园区机构名称" prop="parkName" width="120px" align="center">
        </el-table-column>
        <el-table-column label="园区介绍" prop="intro" align="center">
        </el-table-column>

        <el-table-column label="园区地理坐标" prop="coord" width="120px" align="center">
        </el-table-column>

        <!-- 企业数量对比 -->
        <el-table-column label="企业数量" prop="companyCount" align="center">
        </el-table-column>

        <el-table-column label="所在地区" prop="location" align="center">
        </el-table-column>

        <el-table-column label="创建日期" prop="createDate" align="center">
        </el-table-column>

        <el-table-column label="操作" width="140" align="center">
          <template v-slot="{ row }">
            <div class="flex_top">
              <button-table
                @buttonClick="editItem(row)"
                content="编辑"
                icon="jr-iconjr-icon-edit"
              />
              <button-table
                @buttonClick="deleteItem(row)"
                content="删除"
                icon="jr-iconjr-icon-delect"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="queryInfo.pageNum"
        :page-sizes="[10, 30, 50, 100, 200]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import ImportFilePopup from "@/components/ImportFilePopup/index.vue";
import ButtonTable from "@/components/ButtonTable.vue";
import EarthAreaSelect from "@/components/EarthAreaSelect";
// import Popover from "@/components/Popover.vue";

export default {
  components: {
    SelectTreeRadio,
    ImportFilePopup,
    ButtonTable,
    EarthAreaSelect,
  },
  data() {
    return {
      loading: false,
      total: 2,
      queryInfo: {
        pageSize: 10,
        pageNum: 1,
        industryCategory: "",
        name: "",
        columnName: "create_time",
        order: 1, // 0正序 1倒叙
        country: "中国", // 国家
        province: "", // 省份
        city: "", // 城市
        region: "",
        enterpriseScale: "",
        specialized: "",
        enterpriseMin: "",
        enterpriseTop: "",
      },
      projectTable: [
        {
          id: "CTQY39410",
          dataIntegrity: 95,
          dataQuality: 90,
          name: "医药制造业",
          type: "工业加区",
          area: "50m²",
          intro: "BIRT\n东经89°，北纬44°\n+1+N 模式，共顾",
          companyCount: "56.7万户",
          location: "湖南-开福",
          createDate: "2021年12月1日",
          companyCode: "CTQY-969558552",
          coord: "东经89°，北纬44°",
          parkName:"民营园区"
        },
        {
          id: "CTQY39410",
          dataIntegrity: 95,
          dataQuality: 90,
          name: "医药制造业",
          type: "工业加区",
          area: "50m²",
          intro: "BIRT\n东经89°，北纬44°\n+1+N 模式，共顾",
          companyCount: "56.7万户",
          location: "湖南-开福",
          createDate: "2021年12月1日",
          companyCode: "CTQY-969558552",
          coord: "东经89°，北纬44°",
          parkName:"民营园区"
        },
      ],
      customColors: [
        { color: "#1E9FFF", percentage: 20 },
        { color: "#1E9FFF", percentage: 40 },
        { color: "#1E9FFF", percentage: 60 },
        { color: "#1E9FFF", percentage: 80 },
        { color: "#1E9FFF", percentage: 100 },
      ],
      tags: [
        {
          name: "含规上企业",
          tagName: "enterpriseScale",
        },
        {
          name: "所属行业",
          tagName: "industryCategory",
        },
        {
          name: "含专精特新",
          tagName: "specialized",
        },
        {
          name: "含小巨人企业",
          tagName: "enterpriseMin",
        },
        {
          name: "含上市企业",
          tagName: "enterpriseTop",
        },
      ],
    };
  },
  methods: {
    customColorMethod(percentage) {
      return (
        this.customColors.find((color) => percentage <= color.percentage)
          ?.color || "#1E9FFF"
      );
    },
    multiDelete(e) {},
    search() {},
    popoverClick() {},
    uploadTime() {},
    handleSelectionChange() {},
    sortChange() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    editItem(row) {
      this.$router.push({
        path: "/campus/detail",
        query: {
          id: row.id,
          companyCode: row.companyCode,
          enterpriseType: 1,
        },
      });
    },
    // tag标签关闭
    closeTag(index, name) {
      this.tags.splice(index, 1);

      switch (name) {
        case "industryCategoryList":
          this.queryInfo.industryCategoryListName = "";
          this.queryInfo.industryCategoryList = [];
          break;
        default:
          this.queryInfo[name] = "";
          break;
      }
    },
    deleteItem() {},
    searchCountry() {},
    searchProvince() {},
    searchCity() {},
  },
};
</script>

<style lang="less" scoped>
.projectData {
  /deep/ .el-input-group__append {
    background: #1e9fff;
    color: #fff;
    border: 1px solid #1e9fff;
  }
  .caretTime:hover {
    cursor: pointer;
  }
  .flex_top {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .color1 {
    color: #34c759;
  }
}
.isActiveTime1 {
  color: #1e9fff !important;
}
.iconColor {
  color: #c0c4cc !important;
}
/deep/ .filterInfo .el-form-item__content {
  padding: 0;
}
</style>